<template>
  <section>
    <nav class="is-flex is-justify-content-end mx-2 mb-2">
      <a disabled="disabled" class="button is-primary" @click="onAdd">
        <b-icon icon="plus"></b-icon>
        <span>{{ $t('attributes.add') + $t('attributes.traffic') }}</span>
      </a>
    </nav>

    <b-table
      :data="transfers"
      :loading="loading"
      :mobile-cards="false"
      narrowed
      bordered
    >
      <b-table-column
        field="days"
        :label="$t('attributes.days')"
        centered
        v-slot="props"
      >
        {{ props.row.days }}
      </b-table-column>

      <b-table-column
        field="day"
        :label="$t('attributes.day')"
        centered
        v-slot="props"
      >
        {{ props.row.day }}
      </b-table-column>

      <b-table-column
        field="sort"
        :label="$t('attributes.day_sort')"
        centered
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>

      <b-table-column
        field="direction"
        :label="$t('attributes.traffic_direction')"
        centered
        v-slot="props"
      >
        {{ props.row.direction }}
      </b-table-column>

      <b-table-column
        field="estimated_days"
        :label="$t('attributes.estimated_days')"
        centered
        v-slot="props"
      >
        {{ props.row.estimated_days }}
      </b-table-column>

      <b-table-column
        field="fly_no"
        :label="$t('attributes.fly_no')"
        header-class="has-text-centered"
        v-slot="props"
      >
        {{ props.row.fly_no }}
      </b-table-column>

      <b-table-column
        field="airline"
        :label="$t('attributes.airline')"
        header-class="has-text-centered"
        v-slot="props"
      >
        {{ props.row.airline }}
      </b-table-column>

      <b-table-column
        field="departure_time"
        :label="$t('attributes.departure_time')"
        centered
        v-slot="props"
      >
        {{ props.row.departure_time }}
      </b-table-column>

      <b-table-column
        field="departure_city"
        :label="$t('attributes.departure_city')"
        header-class="has-text-centered"
        v-slot="props"
      >
        {{ props.row.departure_city }}
      </b-table-column>

      <b-table-column
        field="arrive_time"
        :label="$t('attributes.arrive_time')"
        centered
        v-slot="props"
      >
        {{ props.row.arrive_time }}
      </b-table-column>

      <b-table-column
        field="arrive_city"
        :label="$t('attributes.arrive_city')"
        header-class="has-text-centered"
        v-slot="props"
      >
        {{ props.row.arrive_city }}
      </b-table-column>

      <b-table-column
        label="功能"
        header-class="has-text-centered"
        v-slot="props"
      >
        <div class="buttons is-centered">
          <b-button
            disabled="disabled"
            type="is-info"
            size="is-small"
            @click.prevent.stop="onModify(props.row)"
          >
            {{ $t('attributes.modify') }}
          </b-button>
          <b-button
            disabled="disabled"
            type="is-danger"
            size="is-small"
            outlined
            @click.prevent="onDelete(props.row)"
          >
            {{ $t('attributes.delete') }}
          </b-button>
        </div>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div v-if="!loading" class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
          </div>
        </section>
      </template>
    </b-table>

    <b-modal
      :active.sync="isFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <transfer-form
        :group_code="code"
        :transfer="selectedTransfer"
        @send="onSend"
      />
    </b-modal>
    <b-modal
      :active.sync="isFormEditModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <transfer-edit-form :transfer="selectedTransfer" @send="onSend" />
    </b-modal>
  </section>
</template>

<script>
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import TransferForm from './TransferForm'
import TransferEditForm from '@/components/travel_groups/TransferEditForm'

export default {
  name: 'TransferList',
  components: { TransferEditForm, TransferForm },

  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      sending: false,
      code: this.travelGroup.code,
      transfers: [],

      isFormModalActive: false,
      isFormEditModalActive: false,
      selectedTransfer: null
    }
  },
  watch: {
    travelGroup(newGroup) {
      this.code = newGroup.code
      this.isFormModalActive = false
      this.selectedTransfer = null
      this.loadTransfersAsync(newGroup.code)
    }
  },
  mounted() {
    this.loadTransfersAsync(this.travelGroup.code)
  },
  methods: {
    async loadTransfersAsync(code) {
      try {
        this.loading = true
        const api = `${TRAVEL_GROUPS_API}/${code}/transfers`
        const res = await this.axios.get(api)
        const transfers = res.data.data

        this.transfers = transfers
          .sort((t1, t2) => {
            if (t1.day === t2.day) {
              return t1.sort - t2.sort
            } else {
              return t1.day - t2.day
            }
          })
          .map(t => ({
            ...t,
            fly_no: t.fly_no && t.fly_no.trim()
          }))
      } catch (e) {
        this.transfers = []

        notifyService.fetch_error('traffic', e)
      } finally {
        this.loading = false
      }
    },
    onAdd() {
      this.selectedTransfer = {
        id: null,
        days: this.travelGroup.days,
        day: 1,
        sort: 1,
        fly_id: null,
        effect_date: null,
        fly_no: null,
        direction: '去'
      }
      this.isFormModalActive = true
    },
    onModify(item) {
      this.selectedTransfer = item
      this.isFormEditModalActive = true
    },
    onSend(item) {
      if (item.id == null) {
        this.createItem(item)
      } else {
        this.updateItem(item)
      }
    },
    onDelete(item) {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        onConfirm: () => {
          this.deleteItem(item)
        }
      })
    },
    async createItem(item) {
      const api = `${TRAVEL_GROUPS_API}/${this.code}/transfers`

      try {
        this.sending = true
        const res = await this.axios.post(api, item)
        const _item = res.data.data

        const transfers = [...this.transfers, _item]
        this.transfers = transfers.sort((t1, t2) => {
          if (t1.day === t2.day) {
            return t1.sort - t2.sort
          } else {
            return t1.day - t2.day
          }
        })

        this.isFormModalActive = false
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async deleteItem(item) {
      const api = `${TRAVEL_GROUPS_API}/${this.code}/transfers/${item.id}`

      try {
        this.sending = true
        await this.axios.delete(api, item)

        this.transfers = this.transfers.filter(s => s.id !== item.id)

        notifyService.success(this.$t('attributes.delete_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async updateItem(item) {
      const api = `${TRAVEL_GROUPS_API}/update/transfers`
      try {
        this.sending = true
        await this.axios.put(api, item)

        await this.loadTransfersAsync(this.code)
        notifyService.success(this.$t('attributes.update_succeed'))
        this.isFormEditModalActive = false
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  td {
    vertical-align: middle !important;
  }
}
</style>
